module.exports = __webpack_public_path__ + "static/media/rounded-outlined-warning.6963888e.svg";